@if (!sizesService.isMd()) {
  <app-scrollbar class="dropdown__content" [height]="maxHeight + 'px'" (scrollChange)="scrollChanged($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </app-scrollbar>
} @else {
  <div class="dropdown__content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<ng-template #content>
  <div #dropdownContent class="dropdown__content-inner" [ngClass]="{ 'dropdown__content-inner--with-button': button }">
    <ng-content></ng-content>
  </div>
</ng-template>
